export default __webpack_public_path__ + "bf2f12697bad2621ea0f72b36f80e714.jpg";